<template>
<div>
            <div class="Middle_FiveBox">
        <div class="ThreeContBox">
            <img src="@/assets/bt-4.png" class="TwoBoxImg">
            <div class="ThreeBox">
              <div class="ItemBox" v-for="(v,i ) in ChatList " :key="i">
                  <img :src="v.src">
                  <div class="Item_t1">{{v.txt}}</div>
              </div>
            </div>
        </div> 
    </div>
        <div class="FooterBox">
        Copyright © 2018 四川万象坤信科技有限公司 版权所有   蜀ICP备17027980号-2
    </div>
</div>
</template>
<script>
export default {
    data(){
        return{
    ChatList:[{src:require('@/assets/tel.png'),txt:'400-026-9118'},{src:require('@/assets/qq.png'),txt:'3423898158'},{src:require('@/assets/mail.png'),txt:'sp@scwxkx.com'}]
        }
    }
}
</script>
<style lang="scss">
// 5
.Middle_FiveBox{
    width:100%;
    height: 300px;
    background: url('../../assets/lxwmbg.jpg') no-repeat center;
    margin-top:80px ;
    padding-top:50px ;
    padding-bottom:80px ;
    background-size:100% 100% ;
    .ThreeContBox{
        width:1260px;
        margin: 0 auto;
      .TwoBoxImg{
          transform: scale(0.8);
      }
      .ThreeBox{
        margin-top: 50px;
        width:100%;
        display: inline-flex;
        height: 100%;
        .ItemBox:nth-child(2){
          margin: 0 20px;
        }
        .ItemBox{
          flex:1;
          padding: 50px 0;
          background:rgba($color: #ffffff, $alpha: 0.06);
          &:hover{
              background:rgba($color: #293567, $alpha: 0.37);
              cursor: pointer;
              transform: scale(1.1);
              transition: all .5s;
          }
          img{
            width:40px;
            margin: 0 auto;
          }
          div{
            color:#fff;
          }
          .Item_t1{
            margin-top: 10px;
            font-size:15px;
            font-weight: bold;
          }
        }
      }
    }
}
.FooterBox{
    height:60px;
    color:#fff;  
    line-height: 60px;
    font-size: 14px;
    font-weight: 500;
    color: #FFFEFE;
    text-align: center;
    width:100%;
    background: rgba(72, 94, 153, 1);
}
</style>